package pwgs.ui.scenes.customstatscene


class CustomStatControllerFe(props: CustomStatSceneProps, scene: MCustomStatScene) : ACustomStatControllerFe(props, scene) {

    override fun createInitialModel() : CustomStatSceneModel {
        return CustomStatSceneModel(mapOf(), listOf())
    }

    override fun init() {
        call_load()
    }

    fun refreshTodayStat() {
        call_refreshTodayStat()
    }


}

